<template>
  <div class="app-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="充电桩编码">
          <el-input
            v-model="queryParams.pileCode"
            clearable
            placeholder="请输入充电桩编码"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item v-if="isAdminUser" label="所属运营商">
          <el-select v-model="queryParams.operatorId" clearable filterable placeholder="请选择运营商">
            <el-option v-for="item in operatorOptions" :key="item.id" :label="item.operatorName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="action-card" shadow="never">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      <el-button type="success" icon="el-icon-upload" @click="handleImport">设备导入</el-button>
      <el-button type="success" plain icon="el-icon-upload2" @click="handlePortImport">端口导入</el-button>
      <el-dropdown @command="handleTemplateCommand">
        <el-button type="info" icon="el-icon-download">
          选择模板下载<i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="equipment">充电设备导入模板</el-dropdown-item>
          <el-dropdown-item command="port">充电端口导入模板</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      <el-button type="primary" icon="el-icon-upload" @click="handleBatchPush">批量推送</el-button>
      <el-button type="info" plain icon="el-icon-question" @click="handleGuide">操作指引</el-button>
      <input ref="uploadInput" type="file" accept=".xlsx,.xls" style="display: none" @change="handleFileChange">
      <input ref="portUploadInput" type="file" accept=".xlsx,.xls" style="display: none" @change="handlePortFileChange">
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="equipmentList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="所属运营商" prop="operatorName" min-width="140" show-overflow-tooltip />
        <el-table-column label="充电桩编码" prop="pileCode" min-width="140" show-overflow-tooltip />
        <el-table-column label="设备名称" prop="equipmentName" min-width="140" show-overflow-tooltip />
        <el-table-column label="所属站点" prop="stationName" min-width="140" show-overflow-tooltip />
        <el-table-column label="端口数量" prop="portCount" width="100" />
        <el-table-column label="安装地址" prop="address" min-width="180" show-overflow-tooltip />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
              {{ scope.row.statusDesc || (scope.row.status === '1' ? '在线' : '离线') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.pushStatus === 1 ? 'success' : 'info'">
              {{ scope.row.pushStatusDesc || (scope.row.pushStatus === 1 ? '已推送' : '未推送') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="360" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handlePortManage(scope.row)">端口管理</el-button>
            <el-button size="mini" type="text" @click="handlePush(scope.row)">推送</el-button>
            <el-button size="mini" type="text" @click="handleViewPushLog(scope.row)">推送记录</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-show="total > 0"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList"
      />
    </el-card>

    <el-dialog title="推送记录" :visible.sync="pushLogOpen" width="900px">
      <el-table :data="pushLogList" border>
        <el-table-column label="推送时间" prop="createdTime" width="180" />
        <el-table-column label="数据类型" prop="dataType" width="120">
          <template slot-scope="scope">
            <el-tag size="mini">{{ getDataTypeLabel(scope.row.dataType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.pushStatus === 1 ? 'success' : 'danger'">
              {{ scope.row.pushStatus === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接口URL" prop="interfaceUrl" show-overflow-tooltip />
        <el-table-column label="错误信息" prop="errorMessage" width="220" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleRetryPush(scope.row)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pushLogTotal > 0"
        :current-page.sync="pushLogQuery.pageNum"
        :page-size.sync="pushLogQuery.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="pushLogTotal"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="loadPushLog"
        @current-change="loadPushLog"
      />
    </el-dialog>

    <el-dialog :title="title" :visible.sync="open" width="720px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="站点ID" prop="stationId">
          <el-input v-model="form.stationId" placeholder="请输入站点ID" />
        </el-form-item>
        <el-form-item label="充电桩编码" prop="pileCode">
          <el-input v-model="form.pileCode" placeholder="请输入充电桩编码" />
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="form.equipmentName" placeholder="请输入设备名称" />
        </el-form-item>
        <el-form-item label="端口数量">
          <el-input v-model="form.portCount" placeholder="请输入端口数量" />
        </el-form-item>
        <el-form-item label="安装类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio label="小区">小区</el-radio>
            <el-radio label="园区">园区</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="安装地址">
          <el-input v-model="form.address" placeholder="请输入安装地址" />
        </el-form-item>
        <el-form-item label="安装单位" prop="unit">
          <el-input v-model="form.unit" placeholder="请输入安装单位" />
        </el-form-item>
        <el-form-item label="单位联系人" prop="unitContacts">
          <el-input v-model="form.unitContacts" placeholder="请输入单位联系人" />
        </el-form-item>
        <el-form-item label="单位电话" prop="unitPhone">
          <el-input v-model="form.unitPhone" placeholder="请输入单位电话" />
        </el-form-item>
        <el-form-item label="设备状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="1">在线</el-radio>
            <el-radio label="2">离线</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.mark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="open = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="portTitle" :visible.sync="portOpen" width="980px">
      <div class="port-toolbar">
        <span v-if="currentEquipment">当前设备：{{ currentEquipment.pileCode }} / {{ currentEquipment.equipmentName || '-' }}</span>
        <el-button type="primary" size="mini" @click="handleAddPort">新增端口</el-button>
      </div>
      <el-table :data="portList" border v-loading="portLoading">
        <el-table-column label="端口编码" prop="portCode" min-width="140" />
        <el-table-column label="端口名称" prop="portName" min-width="140" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'warning' : 'success'">
              {{ scope.row.statusDesc || (scope.row.status === '1' ? '占用' : '空闲') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.pushStatus === 1 ? 'success' : 'info'">
              {{ scope.row.pushStatusDesc || (scope.row.pushStatus === 1 ? '已推送' : '未推送') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最后推送时间" prop="lastPushTime" width="180" />
        <el-table-column label="备注" prop="mark" min-width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEditPort(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handlePushPort(scope.row)">推送</el-button>
            <el-button size="mini" type="text" @click="handleViewPortPushLog(scope.row)">推送记录</el-button>
            <el-button size="mini" type="text" @click="handleDeletePort(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="portFormTitle" :visible.sync="portFormOpen" width="600px">
      <el-form ref="portForm" :model="portForm" :rules="portRules" label-width="110px">
        <el-form-item label="端口编码" prop="portCode">
          <el-input v-model="portForm.portCode" placeholder="请输入端口编码" />
        </el-form-item>
        <el-form-item label="端口名称">
          <el-input v-model="portForm.portName" placeholder="请输入端口名称" />
        </el-form-item>
        <el-form-item label="端口状态" prop="status">
          <el-radio-group v-model="portForm.status">
            <el-radio label="1">占用</el-radio>
            <el-radio label="2">空闲</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="portForm.mark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="portFormOpen = false">取消</el-button>
        <el-button type="primary" @click="submitPortForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addEquipment,
  batchPushEquipment,
  delEquipment,
  exportEquipment,
  getEquipment,
  importEquipment,
  listEquipment,
  listPushLog,
  pushEquipment,
  retryPush,
  updateEquipment
} from '@/api/coo/equipment'
import {
  addPort,
  delPort,
  getPort,
  importPort,
  listPort,
  pushPort,
  updatePort
} from '@/api/coo/port'
import { listOperator } from '@/api/coo/operator'

export default {
  name: 'EquipmentList',
  data() {
    return {
      loading: true,
      open: false,
      title: '',
      equipmentList: [],
      total: 0,
      ids: [],
      currentEquipment: null,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pileCode: undefined,
        operatorId: undefined
      },
      form: {
        status: '1',
        type: '小区'
      },
      rules: {
        stationId: [{ required: true, message: '站点ID不能为空', trigger: 'blur' }],
        pileCode: [{ required: true, message: '充电桩编码不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '安装类型不能为空', trigger: 'change' }],
        unit: [{ required: true, message: '安装单位不能为空', trigger: 'blur' }],
        unitContacts: [{ required: true, message: '单位联系人不能为空', trigger: 'blur' }],
        unitPhone: [{ required: true, message: '单位电话不能为空', trigger: 'blur' }]
      },
      pushLogOpen: false,
      pushLogDataType: 'equipment',
      pushLogDataId: '',
      pushLogList: [],
      pushLogTotal: 0,
      pushLogQuery: {
        pageNum: 1,
        pageSize: 10
      },
      portOpen: false,
      portTitle: '端口管理',
      portLoading: false,
      portList: [],
      portFormOpen: false,
      portFormTitle: '',
      portForm: {
        status: '2'
      },
      portRules: {
        portCode: [{ required: true, message: '端口编码不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '端口状态不能为空', trigger: 'change' }]
      },
      operatorOptions: [],
      isAdminUser: false
    }
  },
  created() {
    this.initCurrentUser()
    this.initOperatorOptions()
    this.getList()
    this.$guide.startGuideIfNeeded('equipment')
  },
  methods: {
    handleGuide() {
      this.$guide.startGuide('equipment')
    },
    initCurrentUser() {
      const user = JSON.parse(window.sessionStorage.getItem('user') || '{}')
      const roleNames = (user.roles || []).map(item => item.name)
      this.isAdminUser = user.username === 'admin' || roleNames.includes('ROLE_admin')
    },
    initOperatorOptions() {
      if (!this.isAdminUser) {
        return
      }
      listOperator({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.operatorOptions = response.data || []
      })
    },
    getList() {
      this.loading = true
      listEquipment(this.queryParams).then(response => {
        this.equipmentList = response.data || []
        this.total = response.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        pileCode: undefined,
        operatorId: undefined
      }
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
    },
    handleAdd() {
      this.form = {
        status: '1',
        type: '小区'
      }
      this.title = '新增设备'
      this.open = true
    },
    handleUpdate(row) {
      getEquipment(row.id).then(response => {
        if (response.code === 200) {
          this.form = Object.assign({ status: '1', type: '小区' }, response.data)
          this.title = '编辑设备'
          this.open = true
        } else {
          this.$message.error(response.message || '获取设备失败')
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该设备吗？', '提示', {
        type: 'warning'
      }).then(() => delEquipment(row.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '删除成功')
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '删除失败')
        }
      })
    },
    handlePush(row) {
      pushEquipment(row.id).then(response => {
        if (response.code === 200) {
          this.$message.success(response.message || '推送成功')
          this.getList()
        } else {
          this.$message.error(response.message || '推送失败')
        }
      })
    },
    handleBatchPush() {
      if (this.ids.length === 0) {
        this.$message.warning('请先选择要推送的设备')
        return
      }
      this.$confirm('确认批量推送选中的设备吗？', '提示', {
        type: 'warning'
      }).then(() => batchPushEquipment({ ids: this.ids })).then(response => {
        if (response && response.code === 200) {
          this.$message.success(`批量推送完成，成功 ${response.successCount || 0} 条，失败 ${response.failCount || 0} 条`)
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '批量推送失败')
        }
      })
    },
    handleImport() {
      this.$refs.uploadInput.click()
    },
    handlePortImport() {
      this.$refs.portUploadInput.click()
    },
    handleFileChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      importEquipment(formData).then(response => {
        if (response.code === 200) {
          this.$message.success(`导入完成，成功 ${response.successCount} 条，失败 ${response.failCount} 条`)
          this.getList()
        } else {
          this.$message.error(response.message || '导入失败')
        }
        event.target.value = ''
      })
    },
    handlePortFileChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)
      importPort(formData).then(response => {
        if (response.code === 200) {
          this.$message.success(`端口导入完成，成功 ${response.successCount} 条，失败 ${response.failCount} 条`)
          this.getList()
        } else {
          this.$message.error(response.message || '端口导入失败')
        }
        event.target.value = ''
      })
    },
    handleTemplateCommand(command) {
      const link = document.createElement('a')
      link.href = command === 'port' ? '/api/coo/template/port/template' : '/api/coo/template/equipment/template'
      link.download = command === 'port' ? '充电端口导入模板.xlsx' : '充电设备导入模板.xlsx'
      link.click()
    },
    handleExport() {
      exportEquipment({}).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '充电设备数据.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const request = this.form.id ? updateEquipment(this.form) : addEquipment(this.form)
        request.then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '保存成功')
            this.open = false
            this.getList()
          } else {
            this.$message.error(response.message || '保存失败')
          }
        })
      })
    },
    handleViewPushLog(row) {
      this.currentEquipment = row
      this.pushLogDataType = 'equipment'
      this.pushLogDataId = row.pileCode
      this.pushLogOpen = true
      this.pushLogQuery.pageNum = 1
      this.loadPushLog()
    },
    handleViewPortPushLog(row) {
      this.pushLogDataType = 'port'
      this.pushLogDataId = row.portCode
      this.pushLogOpen = true
      this.pushLogQuery.pageNum = 1
      this.loadPushLog()
    },
    loadPushLog() {
      listPushLog({ dataType: this.pushLogDataType, dataId: this.pushLogDataId, ...this.pushLogQuery }).then(response => {
        this.pushLogList = response.data || []
        this.pushLogTotal = response.total || 0
      })
    },
    handleRetryPush(log) {
      this.$confirm('确认重新推送这条记录吗？', '提示', {
        type: 'warning'
      }).then(() => retryPush(log.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '重试成功')
          if (this.currentEquipment) {
            this.loadPushLog()
          }
          this.getList()
        } else if (response) {
          this.$message.error(response.message || '重试失败')
        }
      })
    },
    handlePortManage(row) {
      this.currentEquipment = row
      this.portTitle = `端口管理 - ${row.pileCode}`
      this.portOpen = true
      this.loadPortList()
    },
    loadPortList() {
      if (!this.currentEquipment) return
      this.portLoading = true
      listPort({
        equipmentId: this.currentEquipment.id,
        operatorId: this.currentEquipment.operatorId,
        pageNum: 1,
        pageSize: 100
      }).then(response => {
        this.portList = response.data || []
        this.portLoading = false
      }).catch(() => {
        this.portLoading = false
      })
    },
    handleAddPort() {
      if (!this.currentEquipment) return
      this.portForm = {
        equipmentId: this.currentEquipment.id,
        status: '2'
      }
      this.portFormTitle = '新增端口'
      this.portFormOpen = true
    },
    handleEditPort(row) {
      getPort(row.id).then(response => {
        if (response.code === 200) {
          this.portForm = Object.assign({ status: '2' }, response.data)
          this.portFormTitle = '编辑端口'
          this.portFormOpen = true
        } else {
          this.$message.error(response.message || '获取端口失败')
        }
      })
    },
    handleDeletePort(row) {
      this.$confirm('确认删除该端口吗？', '提示', {
        type: 'warning'
      }).then(() => delPort(row.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '删除成功')
          this.loadPortList()
        } else if (response) {
          this.$message.error(response.message || '删除失败')
        }
      })
    },
    handlePushPort(row) {
      pushPort(row.id).then(response => {
        if (response.code === 200) {
          this.$message.success(response.message || '推送成功')
          this.loadPortList()
        } else {
          this.$message.error(response.message || '推送失败')
        }
      })
    },
    submitPortForm() {
      this.$refs.portForm.validate(valid => {
        if (!valid) return
        const payload = Object.assign({}, this.portForm, {
          equipmentId: this.currentEquipment.id
        })
        const request = payload.id ? updatePort(payload) : addPort(payload)
        request.then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '保存成功')
            this.portFormOpen = false
            this.loadPortList()
            this.getList()
          } else {
            this.$message.error(response.message || '保存失败')
          }
        })
      })
    },
    getDataTypeLabel(type) {
      const map = {
        station: '充电站',
        equipment: '设备',
        port: '充电口',
        order: '订单',
        report: '过程上报',
        alarm: '告警'
      }
      return map[type] || type || '-'
    }
  }
}
</script>

<style scoped>
.search-card,
.action-card {
  margin-bottom: 15px;
}

.port-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
</style>
